module.exports = __webpack_public_path__ + "static/media/footer_piloto.1e4a0142.png";